import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    agreement: graphql(`
        fragment isAgreementHalfHourlyConsumptionConsentAccepted_Agreement on AgreementType {
            __typename
            consents {
                collectHalfHourlyConsumptionData
            }
        }
    `),
}

type IsAgreementHalfHourlyConsumptionConsentAcceptedProps = {
    agreement: FragmentOf<typeof graphQLFragments.agreement>
}

export function isAgreementHalfHourlyConsumptionConsentAccepted(
    props: IsAgreementHalfHourlyConsumptionConsentAcceptedProps
) {
    const agreement = readFragment(graphQLFragments.agreement, props.agreement)

    return !!agreement.consents?.collectHalfHourlyConsumptionData
}

isAgreementHalfHourlyConsumptionConsentAccepted.fragments = graphQLFragments
